import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import { node } from 'prop-types';
export var FormWrapper = _styled("div", {
  target: "eleiwux0",
  label: "FormWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "bl3lvp",
  styles: "display:block;height:100%;width:100%;"
} : {
  name: "bl3lvp",
  styles: "display:block;height:100%;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91c2VyL2NvbW1vbi9Gb3JtV3JhcHBlci5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR3FDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy91c2VyL2NvbW1vbi9Gb3JtV3JhcHBlci5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcbmltcG9ydCB7IG5vZGUgfSBmcm9tICdwcm9wLXR5cGVzJ1xuXG5leHBvcnQgY29uc3QgRm9ybVdyYXBwZXIgPSBzdHlsZWQuZGl2YFxuXHRkaXNwbGF5OiBibG9jaztcblx0aGVpZ2h0OiAxMDAlO1xuXHR3aWR0aDogMTAwJTtcbmBcblxuRm9ybVdyYXBwZXIucHJvcFR5cGVzID0ge1xuXHRjaGlsZHJlbjogbm9kZSxcbn1cbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
FormWrapper.propTypes = {
  children: node
};